import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { QUOTA_TABS, type QuotaTab } from '@/features/admin/shared/tabs';
import { QuotaDetailPage } from '@/features/admin/quotas/quota-detail-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un quota et demande d'augmentation. L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/resources/quotas/$quotaKey')({
  validateSearch: (search: Record<string, unknown>): { tab: QuotaTab } => ({
    tab: QUOTA_TABS.parse(search['tab']),
  }),
  component: QuotaRoute,
});

function QuotaRoute() {
  const { tenant, quotaKey } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="quotas"
      crumbs={[{ label: t('nav.items.quotas') }, { label: quotaKey, mono: true }]}
    >
      <QuotaDetailPage
        tenantId={tenant}
        quotaKey={quotaKey}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
